// What a late-arriving prefill is allowed to overwrite.
//
// Picking a client prefills from that client's last invoice, over several
// network round trips. Whatever the user typed while those were in flight is
// theirs, and the prefill must not take it back -- most damagingly the DATE,
// which the prefill resets to today. That cost the firm real trouble: an
// invoice would quietly revert to today's date after it had been set, and
// nobody would notice unless they were looking.
//
// The rule: a field is filled in only if it is still exactly as it was when
// the client was picked. Anything the user has since touched wins.
//
// Its own module because it has to be a PURE function -- React may invoke a
// setState updater twice -- and because the rule is worth testing on its own
// rather than through a mounted page.

const same = (a, b) => {
  if (a === b) return true;
  // Lines are arrays of objects; a value comparison is what matters here, and
  // these shapes are small and JSON-safe.
  try {
    return JSON.stringify(a) === JSON.stringify(b);
  } catch {
    return false;
  }
};

export function applyPrefill(current, patch, atSelection) {
  if (!patch) return current;
  // No snapshot means nothing to protect: apply the prefill whole, which is
  // the old behaviour and right for a form nobody has touched.
  if (!atSelection) return { ...current, ...patch };

  const allowed = {};
  Object.keys(patch).forEach((key) => {
    if (same(current[key], atSelection[key])) allowed[key] = patch[key];
  });
  return { ...current, ...allowed };
}

export default applyPrefill;
